<template>
  <v-app id="app">
    <navigation-drawer v-if="isNavigationVisible" />
    <v-main>
      <router-view />
    </v-main>
    <NotesDialog :dialog="notesDialog" @close="notesDialog = false" />
  </v-app>
</template>

<script>
import NavigationDrawer from "./components/NavigationDrawer";
import NotesDialog from "./components/NotesDialog";
import { isPublicMode } from "./utils/common";
export default {
  name: "app",
  components: {
    NavigationDrawer,
    NotesDialog
  },
  data() {
    return {
      notesDialog: false,
      isNotesDialogDisplayed: false
    };
  },
  created() {
    const data = localStorage.getItem("enabledObservatories");
    if (data) {
      this.$store.commit("SET_RISK_SUB_CONTROL", {
        observatory: JSON.parse(data)
      });
    }

    if (
      isPublicMode === true &&
      this.isNotesDialogDisplayed === false &&
      ["/", "/mobile"].includes(this.$route.path)
    ) {
      setTimeout(() => {
        this.notesDialog = true;
        this.isNotesDialogDisplayed = true;
      }, 500);
    }

    const manholeImg = new Image();
    manholeImg.src = require("@/assets/images/png/manhole-chart-top.png");
    manholeImg.onload = () => {
      if (manholeImg.complete) {
        this.$store.commit("SET_MANHOLE_CHART_TOP_IMAGE", manholeImg);
      }
    };

    const overflowImg = new Image();
    overflowImg.src = require("@/assets/images/png/overflow-waterway-chart-top.png");
    overflowImg.onload = () => {
      if (overflowImg.complete) {
        this.$store.commit(
          "SET_OVERFLOW_WATERWAY_CHART_TOP_IMAGE",
          overflowImg
        );
      }
    };

    const suijinCarTateImg = new Image();
    suijinCarTateImg.src = require("@/assets/images/png/suijin-chart-car-tate.png");
    suijinCarTateImg.onload = () => {
      if (suijinCarTateImg.complete) {
        this.$store.commit("SET_SUIJIN_CHART_IMAGE_CAR_TATE", suijinCarTateImg);
      }
    };

    const suijinCarYokoImg = new Image();
    suijinCarYokoImg.src = require("@/assets/images/png/suijin-chart-car-yoko.png");
    suijinCarYokoImg.onload = () => {
      if (suijinCarYokoImg.complete) {
        this.$store.commit("SET_SUIJIN_CHART_IMAGE_CAR_YOKO", suijinCarYokoImg);
      }
    };

    const suijinPoleImg = new Image();
    suijinPoleImg.src = require("@/assets/images/png/suijin-chart-pole.png");
    suijinPoleImg.onload = () => {
      if (suijinPoleImg.complete) {
        this.$store.commit("SET_SUIJIN_CHART_IMAGE_POLE", suijinPoleImg);
      }
    };
  },
  computed: {
    isNavigationVisible() {
      return (
        this.$store.getters.isNavigationVisible === true &&
        this.$route.path === "/"
      );
    },
    isMobile() {
      return this.$route.path === "/mobile";
    }
  },
  methods: {
    //
  }
};
</script>

<style lang="scss">
#app {
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-y: hidden;
  .alert-dialog {
    z-index: 2000;
  }
  .progress-linear {
    z-index: 2010;
  }
}
img {
  image-rendering: -webkit-optimize-contrast;
  image-rendering: pixelated;
  -ms-interpolation-mode: nearest-neighbor;
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: crisp-edges;
}
::-webkit-scrollbar {
  display: none;
}
::-webkit-scrollbar {
  width: 0px;
}
.v-snack.v-snack--active.v-snack--bottom {
  z-index: 5000;
}
.v-dialog__content.v-dialog__content--active {
  z-index: 8000 !important;
}
.v-overlay.v-overlay--active.theme--dark {
  z-index: 5000 !important;
}
.leaflet-bottom.leaflet-right {
  .leaflet-control-attribution.leaflet-control {
    pointer-events: painted !important;
  }
}
</style>
